(function(){
  if (window.__nestAdaScannerRemediation20260901b) return;
  window.__nestAdaScannerRemediation20260901b = 'v3-overflow-aware-scroll-region';

  function clean(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function fixHeaderLandmarks(root) {
    var headerWrapper = document.querySelector('#shopify-section-header');
    var stickyHeader = document.querySelector('body > .sticky-header-content');
    var header = document.querySelector('header.site-header');

    if (stickyHeader) {
      stickyHeader.setAttribute('role', 'banner');
      stickyHeader.setAttribute('aria-label', 'Site header');
      if (document.getElementById('NestSiteHeaderAccessibleName')) {
        stickyHeader.setAttribute('aria-labelledby', 'NestSiteHeaderAccessibleName');
      }
    }
    if (headerWrapper && headerWrapper !== stickyHeader) {
      headerWrapper.removeAttribute('role');
      headerWrapper.removeAttribute('aria-label');
      headerWrapper.removeAttribute('aria-labelledby');
    }
    if (header) {
      header.setAttribute('role', 'presentation');
      header.removeAttribute('aria-label');
    }
  }

  function fixProductSpecs(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.product-specs'), function(region) {
      var heading = region.querySelector('h2[id]');
      if (heading && !region.getAttribute('aria-labelledby')) {
        region.setAttribute('aria-labelledby', heading.id);
      }
    });

    Array.prototype.forEach.call((root || document).querySelectorAll('.product-specs .specs-minus, .product-specs .specs-plus'), function(icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('role', 'presentation');
      icon.setAttribute('data-nest-ada-decorative-icon', 'true');
      icon.removeAttribute('aria-label');
      icon.removeAttribute('aria-controls');
      icon.removeAttribute('aria-expanded');
      icon.removeAttribute('tabindex');
    });
  }

  function fixAggregateStars(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.nest-aggregate-stars[data-aggregate-stars]'), function(stars) {
      stars.setAttribute('aria-hidden', 'true');
      stars.setAttribute('data-nest-aggregate-stars-decorative', 'true');
      stars.removeAttribute('role');
      stars.removeAttribute('aria-label');
    });
  }

  function fixTables(root) {
    var tables = (root || document).querySelectorAll('table');
    Array.prototype.forEach.call(tables, function(table) {
      Array.prototype.forEach.call(table.querySelectorAll('tr'), function(row) {
        var firstCell = row.children && row.children[0];
        if (firstCell && firstCell.tagName === 'TH' && !clean(firstCell.textContent)) {
          firstCell.innerHTML = '<span class="visually-hidden">Feature</span>';
        }
      });

      Array.prototype.forEach.call(table.querySelectorAll('tr:first-child th'), function(th) {
        if (!th.getAttribute('scope')) th.setAttribute('scope', 'col');
      });
      Array.prototype.forEach.call(table.querySelectorAll('tr th:first-child'), function(th) {
        if (!th.getAttribute('scope')) th.setAttribute('scope', 'row');
      });
    });
  }

  function fixScrollableRegions(root) {
    var selectors = '.inner-product-table, .comparison-competitors';
    Array.prototype.forEach.call((root || document).querySelectorAll(selectors), function(el) {
      var overflows = el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
      var helperLabel = el.getAttribute('aria-label') === 'Scrollable product comparison';

      if (overflows) {
        el.setAttribute('tabindex', '0');
        if (!el.getAttribute('role')) el.setAttribute('role', 'region');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable product comparison');
        el.setAttribute('data-nest-scroll-region-a11y', 'true');
        return;
      }

      if (el.getAttribute('data-nest-scroll-region-a11y') === 'true' || helperLabel) {
        if (el.getAttribute('tabindex') === '0') el.removeAttribute('tabindex');
        if (helperLabel) el.removeAttribute('aria-label');
        if (el.getAttribute('role') === 'region' && el.getAttribute('data-nest-scroll-region-a11y') === 'true') {
          el.removeAttribute('role');
        }
        el.removeAttribute('data-nest-scroll-region-a11y');
      }
    });
  }

  function fixLinkAccessibleNames(root) {
    var selectors = [
      '.large-tile-text > p:nth-child(2) > b > a[rel="noopener"][target="_blank"]',
      'a[title="Read more customer reviews"]',
      'a[title="More Shipping Details"]',
      'a[title="Nest Bedding Warranty"]'
    ].join(',');

    Array.prototype.forEach.call((root || document).querySelectorAll(selectors), function(link) {
      if (clean(link.textContent)) link.removeAttribute('aria-label');
    });
  }

  function apply(root) {
    fixHeaderLandmarks(root);
    fixProductSpecs(root);
    fixAggregateStars(root);
    fixTables(root);
    fixScrollableRegions(root);
    fixLinkAccessibleNames(root);
  }

  function schedule(root) {
    window.clearTimeout(schedule.timer);
    schedule.timer = window.setTimeout(function(){ apply(root || document); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ apply(document); }, { once: true });
  } else {
    apply(document);
  }

  [250, 800, 1800, 3500, 6000].forEach(function(delay) {
    window.setTimeout(function(){ apply(document); }, delay);
  });

  if (window.MutationObserver && document.body) {
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (
          mutations[i].type === 'attributes' ||
          (mutations[i].addedNodes && mutations[i].addedNodes.length)
        ) {
          schedule(document);
          break;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });
  }
})();
